import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutComponent implements OnInit {

    isVideoPlaying = false;
    videoUrl: SafeResourceUrl;
    videoLink: string;

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
    }

    transform(url: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    /**
     * Permite darle play al video
     */
    playVideo() {
        this.isVideoPlaying = true; 
        const youtubeId = 'WXSophbdXFM'; // Reemplazar con el ID del video
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://www.youtube.com/embed/${youtubeId}?autoplay=1`
        );
        //this.videoLink = `https://www.youtube.com/watch?v=${youtubeId}`;
        this.videoLink = 'assets/video/video_pafar_1.mp4'
    }


    /**
     * Permite cerrar la vista video
     */
    closeVideo() {
        this.isVideoPlaying = false;
    }

}